import { makeActionCreator } from '../../../../utilities'
import { NeuroConstants } from './neuro.constants'

export const setHeadConsciousness = makeActionCreator(NeuroConstants.SET_HEADCONCIOUSNESS, 'headConciousness')
export const setStrokeScale = makeActionCreator(NeuroConstants.SET_STROKESCALE, 'strokeScale')
export const setStrokeScalePNNV = makeActionCreator(NeuroConstants.SET_STROKESCALEPNNV, 'strokeScalePNNV')
export const setStrokeScaleId = makeActionCreator(NeuroConstants.SET_STROKE_SCALE_ID, 'neuroPrStrokeScale')
export const setStrokeScaleScore = makeActionCreator(NeuroConstants.SET_STROKE_SCALE_SCORE, 'strokescaleScore')
export const setStrokeCvaSymptomsResolved = makeActionCreator(
  NeuroConstants.SET_STROKECVASYMPTOMSRESOLVED,
  'strokeCvaSymptomsResolved'
)
export const setStrokeCvaSymptomsResolvedPNNV = makeActionCreator(
  NeuroConstants.SET_STROKECVASYMPTOMSRESOLVEDPNNV,
  'strokeCvaSymptomsResolvedPNNV'
)
export const setThromScreen = makeActionCreator(NeuroConstants.SET_THROMSCREEN, 'thromScreen')
export const setThromScreenPNNV = makeActionCreator(NeuroConstants.SET_THROMSCREENPNNV, 'thromScreenPNNV')
export const setHeadLossCons = makeActionCreator(NeuroConstants.SET_HEADLOSSCONS, 'headLossCons')
export const setHeadFindings = makeActionCreator(NeuroConstants.SET_HEADFINDINGS, 'headFindings')
export const setChemParalyzed = makeActionCreator(NeuroConstants.SET_CHEMPARALYZED, 'chemParalyzed')
export const setDtBaselineSeen = makeActionCreator(NeuroConstants.SET_DTBASELINESEEN, 'dtBaselineSeen')
export const setDtBaselineSeenPNNV = makeActionCreator(NeuroConstants.SET_DTBASELINESEENPNNV, 'dtBaselineSeenPNNV')
export const saveDtBaselineSeen = makeActionCreator(NeuroConstants.SAVE_DTBASELINESEEN)

export const saveNeuro = makeActionCreator(NeuroConstants.SAVE_NEURO)
export const setNeuroResponse = makeActionCreator(NeuroConstants.SET_RESPONSE, 'response')
export const setNeuro = makeActionCreator(NeuroConstants.SET_NEURO, 'neuroData')
export const resetNeuroState = makeActionCreator(NeuroConstants.RESET_NEURO_STATE)

export const setMotorSensoryViaChemParalyzed = makeActionCreator(NeuroConstants.SET_MOTOR_SENSORY_VIA_CHEMPARALYZED)
export const toggleWasPtImm = makeActionCreator(NeuroConstants.TOGGLE_WAS_PATIENT_IMMOBILIZED, '_toggleWasPtImmFlag')
